export default [
  {
    name: 'title',
    component_path: 'modules/templates/blocks/TemplateTitle'
  }
]